import { Section, Center, Row, Col } from '@styled/global';
import styled from 'vue-styled-components';
import 'styled-system';

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n   margin: 0;\n   padding: 0;\n   fontsize: 16px;\n   lineheight: 22px;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n   cursor: pointer;\n   list-style-type: none;\n   text-align: left;\n   flex-direction: column;\n   margin-bottom: 20px;\n   display: flex;\n   flex-direction: column;\n\n   & a {\n      color: ", ";\n   }\n\n   & a:hover: {\n      text-decoration: underline;\n   }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n   vertical-align: middle;\n   text-align: center;\n   text-decoration: none;\n   appearance: none;\n   display: flex;\n   flex-direction: column;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n   padding: 0;\n   margin: 20px 0 0 0;\n   line-height: normal;\n   -webkit-font-smoothing: antialiased;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n   padding: 0;\n   margin: 0;\n   font-weight: bold;\n   text-align: left;\n   color: #000;\n   padding-bottom: 25px;\n   line-height: 40px;\n   -webkit-font-smoothing: antialiased;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n   padding: 10px;\n   text-align: center;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n   margin-top: 10px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n   display: flex;\n   flex-direction: row;\n   flex-wrap: wrap;\n   align-content: stretch;\n   align-items: stretch;\n   justify-content: space-between;\n   margin: 0 3vw 0 3vw;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var Panels = styled("div", {})(_templateObject());
var Panel = styled("div", {})(_templateObject2());
var Body = styled("div", {})(_templateObject3());
var Title = styled("h3", {})(_templateObject4());
var Navigation = styled("nav", {})(_templateObject5());
var NavBar = styled("ul", {})(_templateObject6());
var NavItem = styled("li", {})(_templateObject7(), function (props) {
  return props.theme.primaryColor;
});
var Copy = styled("p", {})(_templateObject8());

// Application imports
var script = {
  props: {
    copy: {
      required: true,
      type: Object
    }
  },
  render: function render() {
    var h = arguments[0];

    var renderBasicsItems = function renderBasicsItems(items) {
      return items.map(function (item, index) {
        var itemArray = [];
        var backgroundStyles = item.icon !== undefined ? item.icon : {};
        var styles = Object.assign({
          lineHeight: "30px",
          fontSize: "18px",
          paddingLeft: "40px"
        }, backgroundStyles);

        if (item.content !== undefined) {
          itemArray.push(h(Copy, {
            "key": "content" + index
          }, [item.content]));
        }

        itemArray.push(h("RouterLink", {
          "key": "link" + index,
          "style": {
            lineHeight: "30px",
            fontSize: "18px"
          },
          "attrs": {
            "to": item.link.url,
            "id": item.link.id
          }
        }, [item.link.label]));
        return h(NavItem, {
          "style": styles,
          "key": "nav" + index
        }, [itemArray]);
      });
    };

    var renderFAQLinks = function renderFAQLinks(links) {
      return links.map(function (link, index) {
        return h(NavItem, {
          "key": "nav" + index
        }, [h("RouterLink", {
          "key": "link" + index,
          "style": {
            lineHeight: "30px",
            fontSize: "18px"
          },
          "attrs": {
            "to": link.url,
            "id": link.id
          }
        }, [link.label])]);
      });
    };

    var renderFAQ = function renderFAQ(faq) {
      var background = faq.icon;
      return h(Col, {
        "attrs": {
          "width": [12, 12, 6]
        }
      }, [h(Body, [h(Title, {
        "style": background
      }, [faq.title]), h(Navigation, [h(NavBar, [renderFAQLinks(faq.links)])])])]);
    };

    var renderBasics = function renderBasics(basics) {
      return h(Col, {
        "attrs": {
          "width": [12, 12, 6]
        }
      }, [h(Body, [h(Title, [basics.title]), h(Navigation, [h(NavBar, [renderBasicsItems(basics.items)])])])]);
    };

    return h(Section, {
      "attrs": {
        "mt": "20px"
      }
    }, [h(Center, [h(Row, [renderFAQ(this.copy.faq), renderBasics(this.copy.basics)])])]);
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

/* script */
const __vue_script__ = script;

/* template */

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = normalizeComponent(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
